import { inputStyles } from '../Input';

export default function InputWrapper(props: Component.DefaultProps) {
  return <div className={inputStyles.wrapper.inputWrapper} style={props.style} children={props.children} />;
}
